import { Component, OnInit } from "@angular/core";
import { OrderService } from "../order-dashboard/order.service";
import { DatePipe } from "@angular/common";
import { DownloadExcelService } from "src/app/services/download-excel.service";

const serviceTypeMap: Record<number, string> = {
  35: 'FCL Regular Single Route',
  36: 'FCL Regular Multiple Route',
  37: 'FCL Breakbulk',
  38: 'FCL Aggregation'
};

@Component({
  selector: "app-completed-fcl",
  templateUrl: "./completed-fcl.component.html",
  styleUrls: ["./completed-fcl.component.scss"],
})
export class CompletedFclComponent implements OnInit {
  orders: any[] = [];
  displayedOrders: any[] = [];
  length: number = 0;
  pageIndex: number = 0;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  dateType = '';
  showCustomDate = false;
  fromDate = ''; 
  toDate = '';
  selectedFilter = 'any';
  selectedStatus = ''; 
  keyword = '';
  excelData: any[];

  constructor(public datePipe: DatePipe, public _orderService: OrderService, public _downloadExcelService: DownloadExcelService) {}

  ngOnInit(): void {
    this.getOrders();
  }

  getOrders() {
    let data = {
      FilterType: this.dateType || "",
      FromDate: this.fromDate || "2021-01-01",
      ToDate: this.toDate || "2025-02-01",
      OrderId: this.selectedFilter === 'order_id' ? this.keyword.trim() : null,
      StrBookingId: this.selectedFilter === 'booking_id' ? this.keyword.trim() : null,
      XPCN: this.selectedFilter === 'xpcn' ? this.keyword.trim() : null,
      XPLS: this.selectedFilter === 'xpls' ? this.keyword.trim() : null
    };

    this._orderService.getCompletedOrders(data).subscribe((response: any) => {
      if (response?.Data) {
        this.orders = this.filterOrders(response.Data);
        console.log('Number of orders:', this.orders.length);
        this.length = this.orders.length;
        this.updateDisplayedOrders();
      } else {
        this.orders = [];
        this.length = 0;
      }
    });
  }

  filterOrders(allOrders: any[]): any[] {
    if (!this.keyword.trim()) return allOrders;
    
    switch (this.selectedFilter) {
      case 'order_id':
        return allOrders.filter(order => order.OrderId?.toUpperCase().includes(this.keyword.toUpperCase()));
      case 'booking_id':
        return allOrders.filter(order => order.StrBookingId?.toUpperCase().includes(this.keyword.toUpperCase()));
      case 'xpcn':
        return allOrders.filter(order => order.XPCN?.toUpperCase().includes(this.keyword.toUpperCase()));
      case 'xpls':
        return allOrders.filter(order => order.XPLS?.toUpperCase().includes(this.keyword.toUpperCase()));
      default:
        return allOrders;
    }
  }

  clearFilters() { 
    this.selectedFilter = 'any';
    this.selectedStatus = '';
    this.keyword = '';
    this.fromDate = '';
    this.toDate = '';
    this.getOrders();
  }

  onFilterChange(event: any) { 
    if (this.selectedFilter !== 'status') this.selectedStatus = ''; 
  }

  setDateFilter(dateFilter: string) { 
    this.dateType = dateFilter; 
    this.showCustomDate = false; 
    this.getOrders(); 
  }

  applyFilters() { 
    this.getOrders(); 
  }

  updateDisplayedOrders(): void {
    const start = this.pageIndex * this.pageSize;
    this.displayedOrders = this.orders.slice(start, start + this.pageSize);
  }

  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updateDisplayedOrders();
  }

  toggleCustomDate() { 
    this.showCustomDate = !this.showCustomDate; 
    if (!this.showCustomDate) { 
      this.fromDate = ''; 
      this.toDate = ''; 
    } 
  }

  public exportAsExcel() {
    this.excelData = [];
    let data = {
      FilterType: this.dateType || "",
      FromDate: this.fromDate || "2021-01-01",
      ToDate: this.toDate || "2025-02-01",
      OrderId: this.selectedFilter === 'order_id' ? this.keyword.trim() : null,
      StrBookingId: this.selectedFilter === 'booking_id' ? this.keyword.trim() : null,
      XPCN: this.selectedFilter === 'xpcn' ? this.keyword.trim() : null,
      XPLS: this.selectedFilter === 'xpls' ? this.keyword.trim() : null
    };

    this._orderService.getCompletedOrders(data).subscribe(
      (response: any) => {
        const list = response?.Data || [];
        if (list.length > 0) {
          this.excelData = list.map((element: any) => ({
            'Booking Id': element.StrBookingId || '-',
            'Customer Name': element.CustomerName || '-',
            'Order ID': element.OrderId || '-',
            'XPCN': element.XPCN || '-',
            'XPLS': element.XPLS || '-',
            'Service Type': serviceTypeMap[element.OrderTypeId] || '-',
            'Origin': element.Origin || '-',
            'Via 1': element.Via_1 || '-',
            'Via 2': element.Via_2 || '-',
            'Destination': element.Destination || '-',
            'Vehicle No.': element.VehicleNumber || '-',
            'Actual Time Of Placement': element.ATP ? this.datePipe.transform(element.ATP, 'dd-MM-yyyy') : '-',
            'Departure Date': element.Departure_Date ? this.datePipe.transform(element.Departure_Date, 'dd-MM-yyyy') : '-',
            'Arrival Date': element.Arrival_Date ? this.datePipe.transform(element.Arrival_Date, 'dd-MM-yyyy') : '-',
            'Transit Time': element.TransitTime || '-',
            'Delay Time': element.DelayTime || '-',
            'Time Taken': element.TimeTaken || '-',
          }));
        }
        this._downloadExcelService.exportAsExcelFile(this.excelData, 'Completed');
      },
      error => {
        console.error("Error exporting orders:", error);
      }
    );
  }
}
